"use client";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { getImageUrl } from "@/lib/utils";
import ImageWithFallback from "./next/NextImage";
import { useEffect, useState } from "react";

interface IImageCarouselProps {
  images: Array<{
    src: string;
    alt: string;
  }>;
  title: string;
}

const ImageCarousel: React.FC<IImageCarouselProps> = ({
  images,

  title,
}) => {
  const [thumbnailPosition, setThumbnailPosition] = useState<"left" | "bottom">(
    "left"
  );

  useEffect(() => {
    const updatePosition = () => {
      if (window.innerWidth < 768) {
        setThumbnailPosition("bottom");
      } else {
        setThumbnailPosition("left");
      }
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);
    return () => window.removeEventListener("resize", updatePosition);
  }, []);

  return (
      <ImageGallery
        items={images.map((i) => ({
          original: getImageUrl(i.src, "products"),
          thumbnail: getImageUrl(i.src, "products"),
          originalAlt: title,
          originalClass: "",
          thumbnailClass: "",
          renderItem: () => (
            <div className="relative bg-white ml-4 border shadow-sm rounded-md lg:h-[60vh] ">
              <ImageWithFallback
                src={getImageUrl(i.src, "products") || ""}
                alt={i?.alt}
                fill={true}
                className="object-contain !relative"
              />
            </div>
          ),
          renderThumbInner: () => (
            <div className="relative bg-white  shadow-md rounded-md h-26  py-5 w-full ring-0">
              <ImageWithFallback
                src={getImageUrl(i.src, "products") || ""}
                alt="product-detail"
                fill={true}
                className="object-contain !relative"
              />
            </div>
          ),
        }))}
        infinite={true}
        thumbnailPosition={thumbnailPosition}
        showFullscreenButton={false}
        showPlayButton={false}
        showBullets={true}
        showNav={false}
        lazyLoad={true}
      />
  );
};

export default ImageCarousel;
